import { FilterCriteria } from '../../FilterStore'
import { FilterChipCloseButton, FilterChipContainer } from './FilterChipStyles'

export function FilterChipSearch({
  search,
  onClose,
  searchLabel = 'Search',
  filterCriteria = 'all',
  isHovered,
}: {
  search: string
  onClose?: () => void
  searchLabel?: string
  filterCriteria?: FilterCriteria
  isHovered?: boolean
}) {
  if (!search) return null
  const isExclusive = filterCriteria === 'neither'
  return (
    <FilterChipContainer isExclusive={isExclusive} isHovered={isHovered}>
      <span>
        {`${searchLabel}: `}
        <b>{search}</b>
      </span>
      {onClose && (
        <FilterChipCloseButton onClick={onClose} isExclusive={isExclusive} />
      )}
    </FilterChipContainer>
  )
}
